export const INLINE_INSTALL_DEFAULT_ERROR =
  'Oops! There was an error trying to install our extension.';
export const INLINE_INSTALL_DEVICE_ERROR =
  'It appears you cannot install Chrome extensions on this browser.';
export const INLINE_INSTALL_FULLSCREEN_ERROR =
  'You cannot install extensions while in fullscreen mode.';
export const GENERIC_ERROR_MESSAGE =
  'Oops, looks like there was an error on our end, please try again.';
export const FORBIDDEN_REMOVE_OAUTH_ERR =
  'Unable to remove profile. Add a password to your account and try again.';

export const PLANNED_DOWNTIME =
  'This Saturday at 12pm PST we will have planned downtime as we make our systems more secure. 🔒';
